import { toast } from 'sonner';
import { Heart, RefreshCw, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

export default function AdminSubscriptions() {
  const { authFetch } = useAdmin();
  const { data, loading, reload } = useFetcher('subscriptions');

  const refund = async (userId) => {
    const reason = window.prompt('Razlog povrata?');
    if (reason === null) return;
    const r = await authFetch(`${API}/admin/subscriptions/${userId}/refund`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason }),
    });
    if (r.ok) { toast.success('Povrat zabilježen'); reload(); }
  };

  if (loading || !data) return <AdminPageHeader icon={Heart} title="Pretplate" testid="admin-subscriptions"><Loader2 className="animate-spin"/></AdminPageHeader>;

  return (
    <div data-testid="admin-subscriptions">
      <AdminPageHeader icon={Heart} title="Pretplate" subtitle="Aktivne pretplate, MRR i povrati novca">
        <button onClick={reload} className="px-3 py-2 rounded bg-zinc-800 hover:bg-zinc-700 text-sm inline-flex items-center gap-1" data-testid="subs-refresh">
          <RefreshCw size={14}/> Osvježi
        </button>
      </AdminPageHeader>
      <div className="px-4 md:px-6 grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <StatCard testid="subs-total" label="Ukupno pretplata" value={data.total} accent="blue"/>
        <StatCard testid="subs-active" label="Aktivnih" value={data.active} accent="green"/>
        <StatCard testid="subs-mrr" label="MRR (EUR)" value={`€${data.mrr_eur}`} accent="violet"/>
        <StatCard testid="subs-refunds" label="Povrati" value={data.refunds} accent="amber"/>
      </div>
      <div className="px-4 md:px-6 pb-6 overflow-x-auto rounded-lg border border-zinc-800 mx-4 md:mx-6">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-900 text-xs text-zinc-400 uppercase">
            <tr>
              <th className="px-4 py-2 text-left">Korisnik</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Plan</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-right">Akcije</th>
            </tr>
          </thead>
          <tbody>
            {(data.items || []).map(u => (
              <tr key={u.id} className="border-t border-zinc-800 hover:bg-zinc-900/50">
                <td className="px-4 py-2">{u.name || '—'}</td>
                <td className="px-4 py-2 break-all">{u.email}</td>
                <td className="px-4 py-2">{u.subscription?.plan || '—'}</td>
                <td className="px-4 py-2">{u.subscription?.status || '—'}</td>
                <td className="px-4 py-2 text-right">
                  <button onClick={() => refund(u.id)} data-testid={`subs-refund-${u.id}`}
                          className="px-2 py-1 rounded bg-amber-700 hover:bg-amber-600 text-xs">Povrat</button>
                </td>
              </tr>
            ))}
            {(data.items || []).length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-zinc-500">Nema pretplata.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
